module.exports = __webpack_public_path__ + "media/images/emblems/Bourrignon-Blazono-caa80d657dedbb212b7ae94925f840a8.png";